import React, { RefObject, useEffect } from 'react';
import { Checkbox, Spin } from 'components/index';
import { PERMISSION_GROUP_KEY_MAPPING } from 'constants/mappings';
import { LoadingOutlined } from '@ant-design/icons';
import { TransferItem } from 'components/common/transferComponent/index';
import { Key } from 'antd/es/table/interface';
import Paragraph from 'antd/es/typography/Paragraph';

interface CustomTransferProps {
  direction: string;
  isLoading: boolean;
  selectKeys: Key[];
  leftSideData: TransferItem[];
  rightSideData: TransferItem[];
  leftBoxRef: RefObject<HTMLDivElement>;
  rightBoxRef: RefObject<HTMLDivElement>;
  handleCheckboxChange: (key: React.Key, checked: boolean) => void;
}

export const CustomTransferList = React.memo(
  ({
    direction,
    isLoading,
    selectKeys,
    leftBoxRef,
    rightBoxRef,
    leftSideData,
    rightSideData,
    handleCheckboxChange,
  }: CustomTransferProps) => {
    useEffect(() => {
      if (isLoading && leftBoxRef.current) {
        leftBoxRef.current.style.overflow = 'hidden';
      } else if (leftBoxRef.current) {
        leftBoxRef.current.style.overflow = 'auto';
      }
    }, [isLoading, leftBoxRef]);
    const renderItems = (items: TransferItem[]) => {
      return items.map((item) => {
        return (
          <label
            key={item.key}
            htmlFor={`checkbox-${item.key}`}
            className={`transfer-item ${item.isTitle ? 'transfer-item-title' : ''}`}
          >
            {!item.isTitle && (
              <Checkbox
                defaultChecked={selectKeys.includes(item.key)}
                id={`checkbox-${item.key}`}
                onChange={(e) => handleCheckboxChange(item.key, e.target.checked)}
              />
            )}
            <Paragraph
              style={{ fontWeight: item.isTitle ? 600 : 400 }}
              ellipsis={{ tooltip: true }}
              className={'transfer-item-text'}
            >
              {item.isTitle ? PERMISSION_GROUP_KEY_MAPPING[item.title] : item.title}
            </Paragraph>
          </label>
        );
      });
    };

    return (
      <div>
        {/* Render left side or right side based on direction*/}
        {direction === 'left' ? (
          <div ref={leftBoxRef} className="transfer-items-box">
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />}
              spinning={isLoading}
              style={{ maxHeight: 200 }}
            >
              {renderItems(leftSideData)}
            </Spin>
          </div>
        ) : (
          <div ref={rightBoxRef} className="transfer-items-box">
            {renderItems(rightSideData)}
          </div>
        )}
      </div>
    );
  }
);
